// extracted by mini-css-extract-plugin
export default {"buttonsBlock":"EditListingWizardButtons_buttonsBlock__l03+q","submitButton":"EditListingWizardButtons_submitButton__mDCbN"};